import classes from "./AdTab.module.scss";
import { AdTabProps } from "./config/tab";
import { memo, useCallback } from "react";

const AdTab = ({ link, label }: AdTabProps) => {
  const handleClick = useCallback(() => {
    window.location.href = link;
  }, [link]);

  return (
    <span className={classes.advertTab} onClick={handleClick}>{label}</span>
  );
};

const adTabMemo = memo(AdTab);

export default adTabMemo;
